export const findAnswerByQuestionTag = (tag, answers, questions) => {
  const question = questions.find(q => q.tags.includes(tag));
  const answer = answers.find(a => a.questionId === question?._id);

  return answer?.answers[0].value;
};

export const findAnswerByTagAndByQuestionTag = (
  answerTag,
  questionTag,
  answers,
  questions
) => {
  const question = questions.find(q => q.tags.includes(questionTag));
  const answer = answers.find(a => a.questionId === question?._id);

  return answer?.answers.find(a => a.tags.includes(answerTag));
};
